import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { mdiMessageTextOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { SwipeableDrawer } from '@material-ui/core';
import ChatMenuContent from './components/ChatMenuContent';
import SideBadge from 'components/SideBadge/SideBadge';
import { useMessageCenterUnreadCount } from './utils/messageCenterScope';

const useStyles = makeStyles((theme) => ({
  iconButton: {
    height: 40,
    padding: 0,
    width: 40,
    [theme.breakpoints.up('sm')]: {
      margin: '0 4px',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}));

const ChatButton = () => {
  const { t } = useTranslation('common');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const classes = useStyles();

  const totalUnreadCount = useMessageCenterUnreadCount();

  return (
    <>
      <IconButton
        className={classes.iconButton}
        onClick={() => setDrawerOpen(true)}
        aria-label={t('navigation.message_center')}
        title={t('navigation.message_center')}
      >
        <SideBadge
          badgeContent={totalUnreadCount}
          color="secondary"
          invisible={totalUnreadCount === 0}
        >
          <Icon path={mdiMessageTextOutline} size={1} />
        </SideBadge>
      </IconButton>
      <SwipeableDrawer
        anchor="right"
        open={drawerOpen}
        onOpen={() => setDrawerOpen(true)}
        onClose={() => setDrawerOpen(false)}
      >
        <ChatMenuContent onClose={() => setDrawerOpen(false)} />
      </SwipeableDrawer>
    </>
  );
};

export default ChatButton;
